import { createOrg } from "../../../../services/auth";
import React from "react";
import { useMutation } from "react-query";
import * as Helpers from "../../../../utils/helpers";
import { useDispatch } from "react-redux";
import { actions as AuthActions } from "../../../../store/authRedux/actions";
import {
  Button,
  Form,
  Input,
  Select,
  notification,
  Typography,
  Upload,
} from "antd";
import { ApartmentOutlined, PlusOutlined } from "@ant-design/icons";
import styles from "./styles.module.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import { serialize } from "object-to-formdata";
import { DownloadAppButton, FieldError } from "../../../../components";
import { INDUSTRY_OPTIONS } from "../../../../constants";

/* The first step of setup. It used to ask for email, phone and postal address
 * as well — four optional fields standing in front of everyone on the way to a
 * kanban board. Those moved to فضای کاری › سازمان, where they can be filled in
 * when there is a reason to. What is left is what actually shapes the workspace:
 * its name, its logo and what the team does — the last one decides which project
 * templates the next step puts first. */
const validationSchema1 = Yup.object({
  title: Yup.string().required("وارد کردن این فیلد الزامی است"),
  industry_id: Yup.number().required("وارد کردن این فیلد الزامی است"),
  avatar: Yup.mixed().notRequired().nullable(),
});

const initialValues = {
  title: undefined,
  industry_id: undefined,
  avatar: undefined,
  color_code: "#1677ff",
};

const Register = (props) => {
  const dispatch = useDispatch();

  const onSubmit = (values) => {
    createOrgMutate.mutate({
      body: serialize(Helpers.removeEmptyFString(values)),
    });
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema1,
    onSubmit,
    validateOnChange: false,
    validateOnBlur: true,
  });

  const createOrgMutate = useMutation(createOrg, {
    onSuccess: (res) => {
      const org = res.organization;
      notification.success({ className: "ds-notif", message: "خوش آمدید!" });
      dispatch(AuthActions.setOrganization(org));
      dispatch(AuthActions.setAuthenticated(true));
    },
    onError: (error) => {},
  });

  const formLoading = createOrgMutate.isLoading;

  return (
    <form
      className={styles.container}
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className={`d-flex align-items-center gap-2 ${styles.page_title}`}>
        <ApartmentOutlined />
        راه‌اندازی فضای کاری
      </div>
      <div className={styles.formCard}>
        <div className={styles.stepBadge}>قدم ۱ از ۴</div>
        <div className={styles.cardIntro}>
          <div className={styles.uploadWrap}>
            <Upload
              name="profile"
              listType="picture-circle"
              className="profile-uploader-org"
              showUploadList={false}
              accept="image/png, image/gif, image/jpeg"
              customRequest={(event) => {
                formik.setFieldValue("avatar", event.file);
              }}
            >
              {formik.values.avatar ? (
                <span className={styles.avatarPreview}>
                  <img
                    src={URL.createObjectURL(formik.values.avatar)}
                    alt="لوگوی سازمان"
                  />
                </span>
              ) : (
                <span className={styles.uploadPlaceholder}>
                  <PlusOutlined />
                </span>
              )}
            </Upload>
          </div>
          <div>
            <Typography.Title level={5} className={styles.cardTitle}>
              اسم تیم یا شرکتت چیه؟
            </Typography.Title>
            <p className={styles.cardDescription}>
              همین یک قدم کافیه؛ بقیه‌ی اطلاعات رو هر وقت خواستی از بخش سازمان
              کامل کن.
            </p>
          </div>
        </div>

        <div className={styles.fields}>
          <Form.Item
            required={true}
            label="نام سازمان"
            className="mb-2 w-100"
            labelCol={{ span: 24 }}
          >
            <Input
              size="large"
              autoFocus
              placeholder="مثلاً تیم محصول تسکامون"
              onChange={(e) => formik.setFieldValue("title", e.target.value)}
              onBlur={() => formik.setFieldTouched("title", true)}
              onPressEnter={formik.submitForm}
            />
            <FieldError formik={formik} name="title" />
          </Form.Item>

          <Form.Item
            required
            label="حوزه‌ی فعالیت"
            className="mb-1 w-100"
            labelCol={{ span: 24 }}
          >
            <Select
              size="large"
              className="w-100"
              showSearch
              allowClear
              placeholder="حوزه‌ی فعالیت تیمت رو انتخاب کن"
              options={INDUSTRY_OPTIONS}
              value={formik.values.industry_id}
              optionFilterProp="label"
              onChange={(value) => formik.setFieldValue("industry_id", value)}
              onBlur={() => formik.setFieldTouched("industry_id", true)}
            />
            <FieldError formik={formik} name="industry_id" />
            <span className={styles.fieldHint}>
              بر اساس این انتخاب، قالب‌های آماده‌ی همین حوزه توی فضای کاریت ساخته می‌شن.
            </span>
          </Form.Item>
        </div>
        <Button
          type="primary"
          size="large"
          className={styles.submitButton}
          block
          loading={formLoading}
          onClick={() => formik.submitForm()}
        >
          ادامه
        </Button>
      </div>
      <div className={styles.downloadWrap}>
        <DownloadAppButton />
      </div>
    </form>
  );
};

export default Register;
